import { useState } from 'react';

import DteBulkDownloadService from '../../services/report/DteBulkDownloadService';
import { SaleDteBulkDownloadRequest } from '../../types/reports/dteBulkDownload/SaleDteBulkDownloadRequest';
import { useBackgroundJob } from '../backgroundjobs/useBackgroundJob';
import useAlerts from '../useAlerts';
import useApiErrorHandler from '../useApiErrorHandler';
import useLoading from '../useLoading';

export const useDteBulkDownload = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const { show } = useAlerts();
  const { handle } = useApiErrorHandler();
  const { showLoadingIndicator, hideLoadingIndicator } = useLoading();

  const { refreshActiveJobs } = useBackgroundJob();

  const download = async (request: SaleDteBulkDownloadRequest) => {
    if (isDownloading) {
      return;
    }

    setIsDownloading(true);
    showLoadingIndicator();

    try {
      const result = await DteBulkDownloadService.download(request);

      if (
        result.mode === 'BACKGROUND_JOB' &&
        result.job?.uuid
      ) {
        await refreshActiveJobs();

        show(
          'info',
          'Descarga en proceso',
          'La descarga se está generando en segundo plano. Puede revisar el progreso desde el panel lateral.'
        );

        return;
      }

      const countMessage =
        result.documentCount === undefined
          ? ''
          : ` Se incluyeron ${result.documentCount} documento(s).`;

      show(
        'success',
        'Descarga completada',
        `Se descargó ${result.fileName}.${countMessage}`
      );
    } catch (error) {
      handle(
        error,
        'No fue posible generar la descarga masiva de DTE.'
      );
    } finally {
      hideLoadingIndicator();
      setIsDownloading(false);
    }
  };

  return {
    download,
    isDownloading,
  };
};